// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"15198b02","150":"474375c5","222":"ab630483","242":"4b5f47d4","379":"23fdd5f8","396":"977f924b","647":"f8f7982e","681":"ba5599c3","978":"177e9012"}[chunkId] + ".chunk.js";
};